import styled from 'styled-components';

export const BreadCrumbContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ChevronContainer = styled.div`
  width: 6px;
  height: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.button<{ isCurrent: boolean }>`
  border: none;
  padding: 0;
  margin: 0;
  background-color: transparent;
  display: flex;
  align-items: center;

  ${({ theme: { font } }) => font.t5};
  color: ${({ theme: { color }, isCurrent }) => (isCurrent ? color.ui2 : color.s1)};
  pointer-events: ${({ isCurrent }) => (isCurrent ? 'none' : 'auto')};
  cursor: pointer;
`;
